var map = {
	"./app.en.json": 9537,
	"./app.hu.json": 2001,
	"./chrome.en.json": 1784,
	"./chrome.hu.json": 4048,
	"./journey.en.json": 6568,
	"./journey.hu.json": 8832,
	"./parameters.en.json": 726,
	"./parameters.hu.json": 7778,
	"./patient.en.json": 7027,
	"./patient.hu.json": 9399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3678;